import { Link } from "react-router-dom";
import CartItemCard from "../components/CartItemCard";
import { useLouveApi } from '../hooks';
import { useAuth } from "../context/AuthContext";


export default function Cart() {
  const { user } = useAuth();
  const { data: userCart } = useLouveApi(`ShoppingCart/${user.user_Id}`)
  console.log({ userCart })

  return (
    <div
      className="p-4 md:px-12 pt-48 min-h-screen"
      style={{ backgroundColor: "#FAFAFA" }}
    >
      <h2 className="text-3xl font-semibold mb-8">Cart</h2>
      {userCart?.length === 0 ?
        <div className="w-full md:h-96 flex items-center justify-center text-center text-2xl text-gray-500 p-4">
          <h4>
            <i className="fas fa-shopping-cart"></i>&nbsp; Cart is empty
          </h4>
        </div>
        :
        <>
          <div className="flex text-center justify-between items-center font-semibold text-sm md:pl-10">
            <div className="w-5/12 text-left">Items</div>
            <div className="w-2/12">Quantity</div>
            <div className="w-2/12">Unit Price(NGN)</div>
            <div className="hidden md:block w-2/12">Sub-total</div>
          </div>

          {/* {
            userCart && userCart.map(item => (
              <CartItemCard />
            ))
          } */}

          {
            [1, 2, 3].map(item => (
              <CartItemCard />
            ))
          }

          <div className="flex justify-end">
            <div className="md:w-30p py-8">
              <div className="flex">
                <div className="w-6/12 text-center">
                  <h4 className="font-bold text-xl">Total</h4>

                </div>
                <div className="w-6/12 text-center">
                  <p className="font-bold text-lg text-primary">100,000</p>
                  <p className="text-xs font-light my-2">delivery fee included</p>
                </div>
              </div>
              <p className="text-primary font-bold text-center my-6 text-sm md:text-base">Shipping to your destination is not available at this time</p>
              <div className="flex justify-center text-sm">
                <Link to="/products"><button className="border border-primary text-primary rounded-lg mx-6 px-4 md:px-8 py-3">Continue shopping</button></Link>
                <Link to="/payment"><button className="bg-primary text-white rounded-lg mx-6 px-4 md:px-8 py-3">Checkout</button></Link>
              </div>
            </div>
          </div>
        </>
      }
    </div>
  );
}
